/*******************************************************************************
 *** MbrAprvRejectReason ** 회원 상세정보 * 반려 사유 입력
********************************************************************************/
import React from "react";
import Button from "@/js/common/ui/Button";
import FeedbackIcon from '@mui/icons-material/Feedback';
import Util from "@/js/common/Util";
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";

interface Props {
    userId: string;
    userNm: string;
    setViewType: Function;
    setMemberModalOpen: Function;
    setCallTime: Function;
}

const MbrAprvRejectReason = ({ userId, userNm, setViewType, setMemberModalOpen, setCallTime }: Props) => {
    const [atrzOpnnCn, setAtrzOpnnCn] = React.useState<string>(""); // 결재의견(반려 사유)

    // 반려 처리
    function goMemberReject() {
        if (Util.isEmpty(atrzOpnnCn)) {
            AppContext.openAlert({
                title: "반려 사유 확인",
                msg: "반려 사유를 입력해주세요.",
                icon: "warning"
            });
            return;
        }

        AppContext.openAlert({
            title: "회원가입 반려",
            msg: userNm + " 회원님의 회원가입을 반려하시겠습니까?",
            icon: "check",
            confirmText: "승인",
            handleConfirm: () => {
                AppContext.showSpinner();
                Axios.dataAccess({
                    url: "system/mbr/mng/process-mbr-aprv-wtng-rjct.do",
                    methodType: "post",
                    paramType: "json",
                    paramData: {
                        userId    : userId,
                        atrzOpnnCn: atrzOpnnCn
                    },
                    onSuccessFn: (res: any) => {
                        setCallTime(new Date());
                        setMemberModalOpen(false);
                        AppContext.hideSpinner();
                        AppContext.openAlert({
                            title: "반려처리 완료",
                            msg: userNm + " 회원님의 회원가입이 반려되었습니다.",
                            icon: "check"
                        });
                    }
                });
            }
        });
    }

    return (
        <div className="w600 bsBdb mxw90vw">
            <div className="csP dpInBlock">
                    <div className="w120 h36 dpFlx aiC jcL h30">
                        <FeedbackIcon style={{ fontSize: 25, color: '#2882B7' }} />
                        <span className="Pretendard-Bold fs16 fc222222 ls075 taU fwB ml5 mb5">반려 사유</span>
                    </div>
                </div>
            <div className="bd1d9d9d9 bdrd1 bgcWhite bsBdb p10">
                {/* 대상 ID */}
                <div className="dpFlx aiC mb10">
                    <div className="w80 flxs0 fw700 fm-c fs13 fc2c3e50 taL">아이디</div>
                    <div className="flxg1">
                        <div className="h36 w180 dpFlx aiC pw10 bsBdb bd1 bdcDDDDDD bdrd5 fm-c fs14 fc333333 ls1 bgcF7F8FA">
                            {userId}
                        </div>
                    </div>
                    <div className="w80 flxs0 fw700 fm-c fs13 fc2c3e50 taL" style={{paddingLeft: "56px"}}>이름</div>
                    <div className="flxg1">
                        <div className="h36 w180 dpFlx aiC pw10 bsBdb bd1 bdcDDDDDD bdrd5 fm-c fs14 fc333333 ls1 bgcF7F8FA">
                            {userNm}
                        </div>
                    </div>
                </div>

                {/* 반려 사유 */}
                <div className="dpFlx aiFs">
                    <div className="w80 flxs0 fw700 fm-c fs13 fc2c3e50 taL pt8">반려 사유</div>
                    <div className="flxg1 bsBdb">
                        <textarea
                            value={atrzOpnnCn}
                            className="w100p h100 bsBdb p10 bd1 bdcDFDFDF bdrd2 fm-c fs14 fc333333 ls1 bgcWhite rszN"
                            maxLength={2000}
                            placeholder="반려 사유를 상세히 입력해주세요."
                            onChange={(e) => setAtrzOpnnCn(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            {/* 하단 버튼바 */}
            <div className="dpFlx jcC mt20">
                <Button buttonName="취소"
                    width={100} height={40}
                    fontFamily="fm-b" fontSize={16} letterSpacing={-1} 
                    variant="styCancelBtn" borderRadius={5}
                    buttonClass="dpFlx aiC jcC"
                    onClickFunc={() => {
                        setViewType("D");
                    }}
                />

                <div className="dpFlx aiC gap10 pl10">
                    <Button buttonName="반려 처리"
                        width={110} height={40}
                        fontFamily="fm-b" fontSize={16} letterSpacing={-1} color="#fff"
                        backgroundColor="#dc3545"
                        borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        onClickFunc={() => { goMemberReject() }}
                    />
                </div>
            </div>
        </div>
    );
};

export default MbrAprvRejectReason;
